import { faStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarOutline } from '@fortawesome/free-regular-svg-icons';

export default {
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    showTotal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tempValue: 0,
      iconSolid: faStar,
      iconOutline: faStarOutline,
    };
  },

  computed: {
    stars() {
      return Math.round(this.tempValue);
    },
    roundedValue() {
      return this.fieldValue || 0;
    },
    maxStars() {
      return +this.question.maxRating;
    },
  },

  watch: {
    fieldValue: {
      immediate: true,
      handler() {
        this.tempValue = this.fieldValue || 0;
      },
    },
  },

  methods: {
    mouseOver(value) {
      if (this.readOnly) {
        return;
      }
      this.tempValue = value + 1;
    },
    mouseLeave() {
      if (this.readOnly) {
        return;
      }
      this.tempValue = this.fieldValue === null ? 0 : this.fieldValue;
    },
    handler(value) {
      if (this.readOnly) {
        return;
      }
      this.$emit('change', value + 1);
    },
    getStarString(starIndex) {
      let starString = '&#9733;';

      for (let i = 0; i < starIndex; i += 1) {
        starString += '&#9733;';
      }

      return starString;
    },
    selectHandler() {
      this.$emit('change', this.tempValue);
    },
  },
};
